var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"messageList",staticClass:"message-list"},_vm._l((_vm.supportTicketMessages),function(ticketMessage){return _c('div',{key:ticketMessage.message_id},[_c('TicketMessage',{attrs:{"message":ticketMessage}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }